export enum PaymentMethod {
  PAYPAL = 'PAYPAL',
  CREDIT_CARD_STRIPE = 'CREDIT_CARD_STRIPE',
  CREDIT_CARD_SQUARE = 'CREDIT_CARD_SQUARE',
  CREDIT_CARD_VIVA = 'CREDIT_CARD_VIVA',
  CREDIT_CARD_PAYMENTSENSE = 'CREDIT_CARD_PAYMENTSENSE',
  CREDIT_CARD_RMS = 'CREDIT_CARD_RMS',
  CREDIT_CARD_TRUSTPAYMENTS = 'CREDIT_CARD_TRUSTPAYMENTS',
  CREDIT_CARD_JCC = 'CREDIT_CARD_JCC',
  CREDIT_CARD_PAYABL = 'CREDIT_CARD_PAYABL',
  CREDIT_CARD_GLOBALPAY = 'CREDIT_CARD_GLOBALPAY',
  CREDIT_CARD_NBGPAY = 'CREDIT_CARD_NBGPAY',
  CREDIT_CARD_MOLLIE = 'CREDIT_CARD_MOLLIE',
  CREDIT_CARD_FYGARO = 'CREDIT_CARD_FYGARO',
  CREDIT_CARD_EPAY = 'CREDIT_CARD_EPAY',
  CREDIT_CARD_APCO_PAY = 'CREDIT_CARD_APCO_PAY',
  CREDIT_CARD_HOBEX = 'CREDIT_CARD_HOBEX',
  CREDIT_CARD_RYFT = 'CREDIT_CARD_RYFT',
  CREDIT_CARD_CARDLINK = 'CREDIT_CARD_CARDLINK',
  CREDIT_CARD_EUROBANK = 'CREDIT_CARD_EUROBANK',
  CREDIT_CARD_ALPHABANK = 'CREDIT_CARD_ALPHABANK',
  CREDIT_CARD_ABA_PAYWAY = 'CREDIT_CARD_ABA_PAYWAY',
  CREDIT_CARD_ROOTLINE = 'CREDIT_CARD_ROOTLINE',
  CREDIT_CARD_SOLIDGATE = 'CREDIT_CARD_SOLIDGATE',
  CREDIT_CARD_EMERCHANT_PAY = 'CREDIT_CARD_EMERCHANT_PAY',
  CREDIT_CARD_NEOSOFT = 'CREDIT_CARD_NEOSOFT',
  CREDIT_CARD_FLITT = 'CREDIT_CARD_FLITT',
  CREDIT_CARD_CITYPAY = 'CREDIT_CARD_CITYPAY',
  CREDIT_CARD_VRPAYMENT = 'CREDIT_CARD_VRPAYMENT',
  CREDIT_CARD_WALLEE = 'CREDIT_CARD_WALLEE',
  CREDIT_CARD_CLEARACCEPT = 'CREDIT_CARD_CLEARACCEPT',
  CREDIT_CARD_MYPOS = 'CREDIT_CARD_MYPOS',
  CREDIT_CARD_PXP = 'CREDIT_CARD_PXP',
  CREDIT_CARD_DNAPAYMENTS = 'CREDIT_CARD_DNAPAYMENTS',
}
